import { render, staticRenderFns } from "./DirectSellSupplier.vue?vue&type=template&id=37ecfce2&"
import script from "./DirectSellSupplier.vue?vue&type=script&lang=js&"
export * from "./DirectSellSupplier.vue?vue&type=script&lang=js&"
import style0 from "./DirectSellSupplier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports